module.exports = __webpack_public_path__ + "img/estadosunidense.e218da2b.svg";